import React, { useState, useEffect, Fragment } from "react";
import {TextField, CircularProgress} from "@material-ui/core";
import {Autocomplete} from '@material-ui/lab';
import { useHistory } from "react-router-dom";
import useStyles from './styles'
import ttAPI from '../../api/ttAPI'
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';


export default function SelectJob(props) {
  const { onSelect, labelName } = props
  const classes = useStyles();
  const history = useHistory();
  const [jobSearchedList, setJobSearchedList] = useState([]);
  const [selectedJobValue, setSelectedJobValue] = useState({});
  const [jobInputValue, setJobInputValue] = useState('');
  const [isSearchJobOpen, setIsSearchJobOpen] = useState(false);

  useEffect( () => {
    async function fetchData() {
      const response = await ttAPI.getOpenJobsByKey(jobInputValue);
      setJobSearchedList(response === null ? [] : response);
    }
    if (jobInputValue !== undefined && jobInputValue !== '' && jobInputValue.length >= 3) {
      fetchData();
    }
  }, [jobInputValue]);


  useEffect(() => {
    if (!isSearchJobOpen) {
      setJobSearchedList([]);
    }
  }, [isSearchJobOpen]);


   // note: for getOptionSelected: if you return false for no match then there will be a warning in the console complain the input does not match what's in the options}
  return (
<div className={classes.contentDiv}>
    <Autocomplete
      id="search-retest"
      className={classes.autocomplete}
      ListboxProps={{ style: { top: '0px', maxHeight: "calc(40vh)"}, position: "bottom-start" }}
      getOptionSelected={(option, value) => {
        if (value === '') {
          return true;
        }
        return Object.keys(option).length === 0 || Object.keys(value).length === 0 ? true : option.name === value.name;}
      }
      getOptionLabel={(option) => {
        if (option === null || option === undefined || option == '') {
          return '';
        }
        return Object.keys(option).length === 0 ? '' : `Job ${option.id}: ${option.customer} - ${option.site}`;
      }}
      renderOption={(option, state) => {
        if (option === null || option === undefined || option == '') {
          return '';
        }

        const matches = match(option.customer, jobInputValue);
        const parts = parse(option.customer, matches);

        const matchesSiteName = match(option.site, jobInputValue);
        const partsSite = parse(option.site, matchesSiteName);

        const matchesJobId = match(option.id !== undefined && option.id !== null ? option.id.toString() : option.id, jobInputValue);
        const partsId = parse(option.id !== undefined && option.id !== null ? option.id.toString() : option.id, matchesJobId);

        return (
        <Fragment key={option.id}>
          <div className={classes.option}>
            <span className={classes.optionSpan}>
            {partsId.map((part, index) => (
              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                {part.text}
              </span>
            ))}
            </span>
            <span className={classes.optionSpan}>
            {parts.map((part, index) => (
              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                {part.text}
              </span>
            ))}
            </span>
            <span className={classes.optionSpan}>
            {partsSite.map((part, index) => (
              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                {part.text}
              </span>
            ))}
            </span>
          </div>
        </Fragment>
      );
      }}
      filterOptions={(options, state) => {/*need to keep this function here for phrase matching*/ return options;}}
      options={jobSearchedList}
      noOptionsText="No Result"
      onChange={(event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
          setSelectedJobValue(newValue);
          onSelect(newValue);
        }
        else {
          setSelectedJobValue('');
          onSelect(undefined);
        }
      }}
      open={isSearchJobOpen}
      onOpen={() => {
        setIsSearchJobOpen(true);
      }}
      onClose={() => {
        setIsSearchJobOpen(false);
      }}
      inputValue={jobInputValue}
      value={selectedJobValue}
      onInputChange={(event, newInputValue,reason) => {
          setJobInputValue(newInputValue);
      }}
      size="small"
      renderInput={(params) => <TextField
                                {...params}
                                style={{ backgroundColor: 'white' }}
                                placeholder={labelName}
                                variant="outlined"
                                  />}
      />
      </div>
  );
}
